import { EditAgentUserModal } from 'features/users/components/modals/edit-agent-user-modal';
import { useNavigate, useParams } from 'react-router-dom';
import { ROUTES } from 'routes/constants';

export const AgentUserUpdateView = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  if (!id) return null;

  const closeModal = () => {
    navigate(ROUTES.USERS_AGENT);
  };

  return (
    <EditAgentUserModal id={id} onClose={closeModal} onSuccess={closeModal} />
  );
};
